import { isEmpty } from "lodash-es";
import { Button, DeleteIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Key } from "antd/lib/table/interface";
import { useDeleteProducts } from "../../../hooks/customization/products/useDeleteProducts";
import { useConfirm } from "melco-shared-logic";

type BulkActionDeleteProductsProps = {
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
  refetch?: () => Promise<any>;
};

export const BulkActionDeleteProducts: React.FC<
  BulkActionDeleteProductsProps
> = ({ selectedRowKeys, setSelectedRowKeys, refetch }) => {
  const { t } = useTranslation();

  const deleteProducts = useDeleteProducts();
  const confirmDelete = useConfirm(
    async () => {
      const successfullyDeletedIds = await deleteProducts(
        selectedRowKeys.map((key) => key.toString())
      );

      if (refetch) {
        refetch();
      }

      // keep items that were not deleted selected
      setSelectedRowKeys(
        selectedRowKeys.filter(
          (id) => !successfullyDeletedIds.includes(id.toString())
        )
      );
    },
    {
      translationPrefix: "products.actions.delete",
      translationOptions: {
        count: selectedRowKeys.length,
      },
    }
  );

  if (isEmpty(selectedRowKeys)) {
    return null;
  }

  return (
    <Button
      key="bulk-delete"
      icon={<DeleteIcon />}
      onClick={() => {
        confirmDelete();
      }}
    >
      {t("products.actions.delete.button")}
    </Button>
  );
};
